import $ from 'jquery';
import { getState, modifyState } from '~src/state';
import { resizeRulers } from '~core/ruler';

const resizeFabricCanvas = (canvas, width, height) => {
  if (!canvas?.setDimensions) return;

  canvas.setDimensions({ width, height });
  canvas.calcOffset?.();
};

export const resizeEditorCanvas = async ({ width, height, zoom }) => {
  const canvas = window.canvas;
  const cursorCanvas = getState('cursorCanvas');
  const previewCanvas = getState('previewCanvas');
  const canvases = new Set([
    canvas,
    cursorCanvas,
    window.cursorCanvas,
    previewCanvas,
  ]);

  canvases.forEach((fabricCanvas) => {
    resizeFabricCanvas(fabricCanvas, width, height);
  });

  if (canvas) {
    const identityViewport = [1, 0, 0, 1, 0, 0];

    if (canvas.setViewportTransform) {
      canvas.setViewportTransform(identityViewport);
    } else {
      canvas.viewportTransform = identityViewport;
    }
    canvas.setZoom?.(1);
  }

  const options = getState('options') || {};
  await modifyState('options', {
    ...options,
    width,
    height,
    zoom,
  });
  await modifyState('initialCanvasZoom', zoom);
  await modifyState('currentCanvasZoom', zoom);

  $('#canvas-zoom, #brush-canvas-container').css({
    transform: `scale(${zoom})`,
    'margin-top': 0,
    'margin-left': 0,
  });
  $('.canvas-container').css({ width, height });

  resizeRulers(width, height);
};
